/**
 * @generated SignedSource<<f8d411f17817ee121843e7d5d96b7484>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type KPICreateAdminTeamQuery$variables = Record<PropertyKey, never>;
export type KPICreateAdminTeamQuery$data = {
  readonly currentStore: {
    readonly publicTeams: ReadonlyArray<{
      readonly color: string | null;
      readonly icon: TeamIcon | null;
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"ListItemTeamIndicator_team">;
    }>;
  };
};
export type KPICreateAdminTeamQuery = {
  response: KPICreateAdminTeamQuery$data;
  variables: KPICreateAdminTeamQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "KPICreateAdminTeamQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "publicTeams",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ListItemTeamIndicator_team"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "KPICreateAdminTeamQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8073ce0e38d3b665e0f02979e54b417c",
    "id": null,
    "metadata": {},
    "name": "KPICreateAdminTeamQuery",
    "operationKind": "query",
    "text": "query KPICreateAdminTeamQuery {\n  currentStore {\n    publicTeams {\n      id\n      color\n      icon\n      name\n      ...ListItemTeamIndicator_team\n    }\n    id\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment ListItemTeamIndicator_team on Team {\n  ...AHTeamIconCircle\n}\n"
  }
};
})();

(node as any).hash = "6e3b77f25caa40c7f5e67aaaeca754d4";

export default node;
